import style from './toolTipCompoStyle.module.css';

const ToolTip2 = () => {
  return (
    <div className={style.toolTip}>
      <span className={style.toolTipText}>Klik untuk melihat lebih rinci</span>
      <span>
        <img
          src={require('../../assets/images/iconInformation.png')}
          alt=""
          className={style.tip}
        />
      </span>
    </div>
  );
};
export default ToolTip2;
